import { useEffect, useRef } from "react";
import { Input } from "./ui/input";

let mapsPromise = null;
function loadMaps(key) {
  if (window.google?.maps?.places) return Promise.resolve();
  if (mapsPromise) return mapsPromise;
  mapsPromise = new Promise((resolve, reject) => {
    const s = document.createElement("script");
    s.src = `https://maps.googleapis.com/maps/api/js?key=${key}&libraries=places&language=it&region=IT`;
    s.async = true;
    s.defer = true;
    s.onload = resolve;
    s.onerror = reject;
    document.head.appendChild(s);
  });
  return mapsPromise;
}

// Porta il dropdown dei suggerimenti (.pac-container) sopra ai dialog Radix.
function ensurePacStyle() {
  if (document.getElementById("pac-zfix")) return;
  const st = document.createElement("style");
  st.id = "pac-zfix";
  st.textContent = ".pac-container{z-index:100000 !important}";
  document.head.appendChild(st);
}

export function AddressAutocomplete({ value, onChange, onSelect, placeholder, ...rest }) {
  const inputRef = useRef(null);
  const acRef = useRef(null);

  useEffect(() => {
    const key = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
    if (!key) return;
    let cancelled = false;
    ensurePacStyle();
    loadMaps(key)
      .then(() => {
        if (cancelled || !inputRef.current || acRef.current) return;
        const ac = new window.google.maps.places.Autocomplete(inputRef.current, {
          componentRestrictions: { country: "it" },
          fields: ["formatted_address", "address_components", "geometry"],
          types: ["address"],
        });
        acRef.current = ac;
        ac.addListener("place_changed", () => {
          const place = ac.getPlace();
          const addr = place?.formatted_address || inputRef.current?.value || "";
          onSelect?.(addr, place);
        });
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []); // eslint-disable-line

  return (
    <Input
      ref={inputRef}
      value={value}
      onChange={(e) => onChange?.(e.target.value)}
      onKeyDown={(e) => { if (e.key === "Enter") e.preventDefault(); }}
      placeholder={placeholder}
      autoComplete="off"
      {...rest}
    />
  );
}
